import BaseProxy from './BaseProxy';

class Country extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/file', parameters);
    }
}

export default Country;



// WEBPACK FOOTER //
// ./src/api/File.js